import { render } from "./IconArrow.vue?vue&type=template&id=35cb2881&scoped=true"
import script from "./IconArrow.vue?vue&type=script&lang=js"
export * from "./IconArrow.vue?vue&type=script&lang=js"

import "./IconArrow.vue?vue&type=style&index=0&id=35cb2881&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cb2881"]])

export default __exports__